import { apiClient } from '../../../gateways/api'
import type { FetchGeblokkeerdeWeken } from '../types/FetchGeblokkeerdeWeken'

export { fetchHerplanGeblokkeerdeWeken, initialState }

const fetchHerplanGeblokkeerdeWeken = async ({
  gebiedscodes,
  organisatie,
}: {
  gebiedscodes: string[]
  organisatie: string
}): Promise<FetchGeblokkeerdeWeken['data']> => {
  const { data } = await apiClient({
    method: 'POST',
    url: '/rest/planning/geblokkeerdeweken/search',
    data: {
      filters: [
        { name: 'status', value: 'actief', operator: 'eq' },
        {
          name: 'gebiedscode',
          value: gebiedscodes,
          operator: 'in',
        },
        {
          name: 'organisatie',
          value: organisatie,
          operator: 'eq',
        },
      ],
    },
  })

  return data
}

const initialState: FetchGeblokkeerdeWeken = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
}
